import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import app from './App';
import '@backstage/ui/css/styles.css';
import './buiOverrides.css';

ReactDOM.createRoot(document.getElementById('root')!).render(app);
